/* AMBESA · shipping price, delivery time and customs for the shopper's country (markup: snippets/amb-ship.liquid).
   Liquid writes these lines for the country picked in the store's country selector. Shoppers who never pick
   one browse as Finland: for them this script asks Shopify once per visit which country they browse from,
   repaints the lines and picks the matching delivery timeline under the buy button (product page sections
   ss_delivery_timer_KXGeK9 for the EU, ss_delivery_intl for the rest, ss_delivery_preorder for preorders).
   Shoppers browsing in another currency see the shipping price converted with Shopify's own rate.
   Lines marked data-own="1" (product page) and cart boxes with data-own above 0 belong to products with
   their own shipping (tag own-shipping, the windbreaker): free in the EU, their own rate elsewhere.
   The cart box (data-amb-ship-box) is drawn again in full: title, progress bar and price line.
   The rules match snippets/amb-ship.liquid: keep both in step. */
(function () {
  'use strict';
  var doc = document;
  var cfgEl = doc.getElementById('amb-ship-config');
  var cfg = null;
  try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : 'null'); } catch (e) { cfg = null; }
  if (!cfg) return;

  var EU = String(cfg.eu || '').split(',');
  var DDP = String(cfg.ddp || '').split(',');
  var MEA = String(cfg.mea || '').split(',');
  var country = { code: cfg.loc, name: cfg.locName };
  var TIMER = { eu: '__ss_delivery_timer_KXGeK9', intl: '__ss_delivery_intl', pre: '__ss_delivery_preorder' };

  var cur = (window.Shopify && window.Shopify.currency) || {};
  var active = String(cur.active || 'EUR').toUpperCase();
  var rate = parseFloat(cur.rate);
  var convert = active !== 'EUR' && rate > 0;

  function money(eur) {
    if (!convert) return '€' + eur.toFixed(2).replace('.', ',');
    var value = eur * rate;
    try {
      return new Intl.NumberFormat(doc.documentElement.lang || 'en', { style: 'currency', currency: active }).format(value);
    } catch (e) {
      return active + ' ' + value.toFixed(2);
    }
  }

  function rules(cc) {
    var r = { region: 'other', eur: 0, jeur: 0, jfree: false };
    if (EU.indexOf(cc) > -1) { r.region = 'eu'; r.eur = 9.99; r.jfree = true; }
    else if (DDP.indexOf(cc) > -1) {
      r.region = 'ddp';
      r.eur = cc === 'GB' ? 14.99 : (cc === 'NO' || cc === 'CH') ? 19.99 : 24.99;
      r.jeur = (cc === 'GB' || cc === 'NO' || cc === 'CH') ? 9.99 : r.eur;
    }
    else if (MEA.indexOf(cc) > -1) { r.region = 'mea'; r.eur = 24.90; r.jeur = r.eur; }
    else if (cc === 'IS') { r.eur = 9.99; r.jeur = 9.99; }
    r.rate = r.eur ? money(r.eur) : '';
    r.jrate = r.jeur ? money(r.jeur) : '';
    r.sum = r.eur && r.jeur ? money(Math.round((r.eur + r.jeur) * 100) / 100) : '';
    r.days = r.region === 'eu' ? '5 to 7 business days' : '7 to 10 business days';
    r.customs = r.region === 'eu' ? 'No customs fees. Ships from Helsinki.'
      : r.region === 'ddp' ? 'Duties and import taxes are paid at checkout. Nothing to pay on delivery.'
      : 'Import fees may be due on delivery.';
    return r;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function markup(kind, node) {
    var r = rules(country.code);
    var name = esc(country.name || country.code);
    if (kind === 'line') {
      if (node.getAttribute('data-own') === '1') {
        if (r.jfree) return '<span class="amb-ship-line__free">Free shipping</span> to ' + name + '.';
        return r.jrate ? 'Shipping to ' + name + ' <b>' + r.jrate + '</b>.' : '';
      }
      return r.rate
        ? 'Shipping to ' + name + ' <b>' + r.rate + '</b>. <span class="amb-ship-line__free">Free on 2+ jerseys</span>'
        : '<span class="amb-ship-line__free">Free shipping on 2+ jerseys</span>';
    }
    if (kind === 'delivery') return '<strong>Delivery in ' + r.days + '</strong>';
    if (kind === 'customs') return esc(r.customs);
    return null;
  }

  /* cart box: same states as snippets/amb-ship.liquid (mode cart) */
  function boxState(r, n, own, name) {
    var to = 'Shipping to ' + name + ': ';
    var s;
    if (own > 0) {
      if (r.jfree) {
        s = n === 1
          ? { cls: 'is-own', title: 'Add 1 more jersey for free shipping', bar: 50, sub: to + '<b>' + r.rate + '</b> for the jersey. The windbreaker ships free.' }
          : { cls: 'is-own is-free', title: 'Free shipping unlocked', bar: 100, sub: to + '<b>Free</b>' };
      } else if (n === 0) {
        s = { cls: 'is-own', title: 'Windbreaker shipping', bar: 0, sub: to + '<b>' + r.jrate + '</b>. Add 2 jerseys and they ship free.' };
      } else if (n === 1) {
        s = { cls: 'is-own', title: 'Add 1 more jersey for free jersey shipping', bar: 50, sub: to + '<b>' + r.sum + '</b> (windbreaker ' + r.jrate + ' + jersey ' + r.rate + ')' };
      } else {
        s = { cls: 'is-own is-jerseys-free', title: 'Free jersey shipping unlocked', bar: 100, sub: to + '<b>' + r.jrate + '</b> for the windbreaker. Jerseys ship free.' };
      }
    } else if (n >= 2) {
      s = { cls: 'is-free', title: 'Free shipping unlocked', bar: 100, sub: to + '<b>Free</b>' };
    } else {
      s = { cls: '', title: 'Add 1 more jersey for free shipping', bar: 50, sub: to + '<b>' + r.rate + '</b>' };
    }
    if (!r.rate) s.sub = '';
    return s;
  }

  /* write only what differs, so content the theme draws again (cart and product form updates) is
     always corrected and nothing loops */
  var scratch = doc.createElement('div');
  function setHTML(node, html) {
    scratch.innerHTML = html;
    if (node.innerHTML !== scratch.innerHTML) node.innerHTML = html;
  }

  function paintBoxes() {
    var r = rules(country.code);
    var name = esc(country.name || country.code);
    Array.prototype.forEach.call(doc.querySelectorAll('[data-amb-ship-box]'), function (box) {
      var n = parseInt(box.getAttribute('data-count'), 10) || 0;
      var own = parseInt(box.getAttribute('data-own'), 10) || 0;
      var s = boxState(r, n, own, name);
      var cls = ('amb-ship-cart ' + s.cls).trim();
      if (box.className !== cls) box.className = cls;
      var title = box.querySelector('[data-amb-ship-title]');
      if (title && title.textContent !== s.title) title.textContent = s.title;
      var bar = box.querySelector('.amb-ship-cart__bar');
      if (bar) {
        if (bar.hidden !== !s.bar) bar.hidden = !s.bar;
        var fill = bar.querySelector('span');
        if (fill && s.bar && fill.style.width !== s.bar + '%') fill.style.width = s.bar + '%';
      }
      var sub = box.querySelector('[data-amb-ship-sub]');
      if (sub) setHTML(sub, s.sub);
    });
  }

  function findTemplate(key) {
    var list = doc.querySelectorAll('template[id^="ss-delivery-"]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].id.slice(-key.length) === key) return list[i];
    }
    return null;
  }

  function placeTimer() {
    var holder = doc.querySelector('[data-amb-timer]');
    if (!holder) return;
    var key = holder.getAttribute('data-preorder') === '1' ? TIMER.pre : (rules(country.code).region === 'eu' ? TIMER.eu : TIMER.intl);
    var tmpl = findTemplate(key);
    if (!tmpl && key === TIMER.intl) { key = TIMER.eu; tmpl = findTemplate(key); }
    if (!tmpl || !tmpl.content || !tmpl.content.firstElementChild) return;
    Array.prototype.forEach.call(doc.querySelectorAll('.add-to-cart-button'), function (btn) {
      if (btn.closest('sticky-add-to-cart, .sticky-add-to-cart')) return;
      var form = btn.closest('form') || btn.parentElement;
      if (!form) return;
      var old = form.querySelector('.ss-delivery-clone');
      if (old && old.getAttribute('data-key') === key) return;
      if (old) old.remove();
      var clone = tmpl.content.firstElementChild.cloneNode(true);
      clone.classList.add('ss-delivery-clone');
      clone.setAttribute('data-key', key);
      btn.insertAdjacentElement('afterend', clone);
    });
  }

  function paint() {
    if (country.code !== cfg.loc || convert) {
      Array.prototype.forEach.call(doc.querySelectorAll('[data-amb-ship]'), function (node) {
        var html = markup(node.getAttribute('data-amb-ship'), node);
        if (html !== null) setHTML(node, html);
      });
      paintBoxes();
    }
    placeTimer();
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; paint(); });
  }

  function useCountry(code, name) {
    if (!code || code === country.code) return;
    country = { code: code, name: name || code };
    paint();
  }

  function detect() {
    /* a shopper who picked a country already sees it: Liquid used it */
    if (cfg.loc !== cfg.home) return;
    try {
      var cached = JSON.parse(window.sessionStorage.getItem('amb-geo') || 'null');
      if (cached && cached.code) { useCountry(cached.code, cached.name); return; }
    } catch (e) {}
    if (!window.fetch) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country;
        if (!c || !c.handle) return;
        var g = { code: String(c.handle).toUpperCase(), name: String(c.name || '') };
        try { window.sessionStorage.setItem('amb-geo', JSON.stringify(g)); } catch (e) {}
        useCountry(g.code, g.name);
      })
      .catch(function () {});
  }

  function init() {
    paint();
    detect();
    /* the cart drawer and the product form re-render after changes: repaint what comes back */
    if (window.MutationObserver) new MutationObserver(queue).observe(doc.body, { childList: true, subtree: true });
    doc.addEventListener('shopify:section:load', queue);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})();